import { render, staticRenderFns } from "./Persona_deshabilitarMasiva.vue?vue&type=template&id=1e190f7b&scoped=true"
import script from "./Persona_deshabilitarMasiva.vue?vue&type=script&lang=js"
export * from "./Persona_deshabilitarMasiva.vue?vue&type=script&lang=js"
import style0 from "./Persona_deshabilitarMasiva.vue?vue&type=style&index=0&id=1e190f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e190f7b",
  null
  
)

export default component.exports